import { render, staticRenderFns } from "./ManterComarcaExibir.vue?vue&type=template&id=44209086&scoped=true&"
import script from "./ManterComarcaExibir.vue?vue&type=script&lang=js&"
export * from "./ManterComarcaExibir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44209086",
  null
  
)

export default component.exports